import { render, staticRenderFns } from "./Shipping.vue?vue&type=template&id=6920650c&scoped=true"
import script from "./Shipping.vue?vue&type=script&lang=js"
export * from "./Shipping.vue?vue&type=script&lang=js"
import style0 from "./Shipping.vue?vue&type=style&index=0&id=6920650c&prod&lang=scss&scoped=true"
import style1 from "./Shipping.vue?vue&type=style&index=1&id=6920650c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6920650c",
  null
  
)

export default component.exports